import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import BookshelfView from './components/pages/bookshelf/BookshelfView';
import Story from './components/pages/Story/StoryView';
import Landing from './components/pages/Landing/LandingView';
import Chester from './components/Chester';
import DiceRoller from './components/DiceRoller';
import BackgroundMusic from './components/BackgroundMusic';
import MarkdownTest from './components/pages/Story/MarkdownTest';
import TableView from './components/pages/Table/TableView';
import StatblockViewer from './components/pages/Statblocker/StatblockViewer';
import AuthCallback from './components/auth/AuthCallback';
import SubscriptionRequired from './components/pages/Subscription/SubscriptionRequired';
import ProtectedRoute from './components/auth/ProtectedRoute';
import VaultView from './components/pages/Vault/VaultView';
import TravelView from './components/pages/Travel/TravelView';
import { StoryProvider } from './context/StoryContext';
import { AudioProvider } from './context/AudioContext';
import { ChatProvider } from './context/ChatContext';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import { 
  initGA, 
  logPageView, 
  trackNavigation,
  trackError 
} from './config/analytics';
import MusicPlayer from './components/MusicPlayer/MusicPlayer';

const AppContent = () => {
  const location = useLocation();

  useEffect(() => {
    initGA();
    logPageView('App Load');
  }, []);

  useEffect(() => {
    const previousPath = location.state?.from || '/';
    trackNavigation(previousPath, location.pathname);
    logPageView();
  }, [location]);

  return (
    <ErrorBoundary onError={(error, info) => trackError(error, info)}>
      <div className="App">
        <DiceRoller />
        <MusicPlayer />
        {location.pathname !== '/' && 
         location.pathname !== '/auth/callback' && 
         location.pathname !== '/subscription-required' ? 
          <Chester /> : null}
        {location.pathname !== '/' && 
         location.pathname !== '/auth/callback' && 
         location.pathname !== '/subscription-required' ? 
          <Navbar /> : null}

        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/subscription-required" element={<SubscriptionRequired />} />
          
          {/* Protected Routes */}
          <Route 
            path="/bookshelf" 
            element={
              <ProtectedRoute>
                <BookshelfView />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/story" 
            element={
              <ProtectedRoute>
                <Story />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/story/:id" 
            element={
              <ProtectedRoute>
                <Story />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/table" 
            element={
              <ProtectedRoute>
                <TableView />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/markdown-test" 
            element={
              <ProtectedRoute>
                <MarkdownTest />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/statblocker" 
            element={
              <ProtectedRoute>
                <StatblockViewer />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/vault" 
            element={
              <ProtectedRoute>
                <VaultView />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/travel" 
            element={
              <ProtectedRoute>
                <TravelView />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </div>
    </ErrorBoundary>
  );
};

// App wrapper with all providers
const App = () => {
  return (
    <Router>
      <AuthProvider>
        <ChatProvider>
          <StoryProvider>
            <AudioProvider>
              <AppContent />
            </AudioProvider>
          </StoryProvider>
        </ChatProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;